/**
 * Email Regex Pattern
 * Strict email validation:
 * - Must start and end with alphanumeric
 * - Allows dots, hyphens, underscores in the middle
 * - No consecutive dots, no dots at start/end
 * - Valid domain with TLD (2+ characters)
 */
export const emailRegex =
  /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/;

/**
 * Password Regex Patterns
 * Used for strong password validation
 */
export const passwordRegex = {
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
  number: /[0-9]/,
  specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/,
};
